export default __webpack_public_path__ + "static/media/NoDataImage.d696f406.svg";